import $ from "cash-dom";

export default {
  install(Vue) {
    const setPadding = function($el) {
      // pokud je navigace sticky na podstrankach
      if (
        $("html").hasClass("has-fixed-header") &&
        $("html").hasClass("subpage")
      ) {
        const fixedHeaderHeight = $(".fixed-header").height();
        $el.css("padding-top", fixedHeaderHeight);

        var $winW = $(window).width();

        // pokud je navigace sticky na podstrankach
        if (
          $("html").hasClass("has-fixed-header") &&
          $("html").hasClass("subpage")
        ) {
          const fixedHeaderHeight = $(".fixed-header").height();

          if ($winW > 767) {
            $el.css("padding-top", fixedHeaderHeight);
          } else {
            $el.css("padding-top", 0);
          }

          if ($winW >= 992) {
            // var $topNavigation = $('.fixed-header')
            var $innerNavigation = $(".fixed-header2");

            if ($innerNavigation.length && $winW > 992) {
              $innerNavigation.css("top", fixedHeaderHeight);
              $el.css("padding-top", fixedHeaderHeight + 40);
            }
          }
        }
      }
    };

    Vue.directive("paddinger-header", {
      mounted(el) {
        const $el = $(el);
        $(window)
          .on("resize", function() {
            setPadding($el);
          })
          .trigger("resize");
      },

      updated() {}
    });
  }
};
